/*
 * blush CRO 2026-10-15: mobile sort button on collection and search pages ([data-blush-cro-sort], snippet
 * blush-cro-coll-sort) sets sort_by through facets.js (FacetFiltersForm.renderPage), the same client-side render
 * and history entry as the filter drawer. Without facets.js it falls back to a normal navigation.
 */
(() => {
  if (window.blushCroColl) return;
  window.blushCroColl = true;

  const currentParams = () => {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    return params;
  };

  const apply = (params) => {
    const FacetFiltersForm = customElements.get('facet-filters-form');
    const query = params.toString();
    if (!FacetFiltersForm || typeof FacetFiltersForm.renderPage !== 'function' || !document.getElementById('product-grid')) {
      window.location.search = query;
      return Promise.resolve(false);
    }
    return Promise.resolve(FacetFiltersForm.renderPage(query));
  };

  const syncSort = () => {
    const current = new URLSearchParams(window.location.search).get('sort_by');
    document.querySelectorAll('[data-blush-cro-sort]').forEach((select) => {
      const fallback = select.dataset.default || '';
      const wanted = current && Array.from(select.options).some((option) => option.value === current) ? current : fallback;
      if (wanted && select.value !== wanted) select.value = wanted;
      select.closest('.blush-cro-coll-sort')?.classList.toggle('is-custom', Boolean(current) && current !== fallback);
    });
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest?.('[data-blush-cro-sort]');
    if (!select) return;
    const params = currentParams();
    params.set('sort_by', select.value);
    select.closest('.blush-cro-coll-sort')?.classList.toggle('is-custom', select.value !== select.dataset.default);
    apply(params);
  });

  // Filters applied from the drawer, Back/Forward: keep the sort button in step with the URL.
  window.addEventListener('popstate', () => window.setTimeout(syncSort, 0));
  const watchGrid = () => {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    new MutationObserver(syncSort).observe(container, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchGrid);
  else watchGrid();
})();
